<template>
  <ra-card v-loading="loading">
    <template slot="header">
      <p>Daily Active Users</p>
      <el-dropdown @command="setRange">
        <el-button type="plain" plain size="small">
          {{ rangeTypes[range] }} <i class="ra-icon--chevron-down"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(value, key, i) in rangeTypes"
            :key="i"
            :class="{ selected: key === range }"
            :command="key"
            >{{ value }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    <template slot="content">
      <line-chart
        v-if="dataAvailable"
        :data="requestChart.data"
        :labels="requestChart.labels"
      />
      <ra-empty-state v-else :type="'line-chart'" />
    </template>
  </ra-card>
</template>

<script>
import LineChart from "@/components/Chart/LineChart";
import apiConstants from "@/apiConstants";

export default {
  name: "DailyActiveUsers",
  props: {
    appCode: {
      type: String,
      default: ""
    },
    period: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    LineChart
  },
  data() {
    return {
      loading: false,
      range: "day",
      rangeTypes: {
        day: "Day",
        month: "Month",
        year: "Year"
      },
      labels: [],
      data: [],
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  computed: {
    requestChart() {
      const labels = this.labels;
      const data = this.data;
      return { data, labels };
    },

    dataAvailable() {
      return this.labels.length && this.data.length;
    }
  },

  watch: {
    appCode() {
      this.getDailyActiveUsers();
    },

    period: {
      deep: true,
      handler() {
        this.getDailyActiveUsers();
      }
    },

    range() {
      this.getDailyActiveUsers();
    }
  },

  created() {
    if (this.appCode) {
      this.getDailyActiveUsers();
    }
  },

  methods: {
    setRange(group) {
      this.range = group;
    },

    getDailyActiveUsers() {
      this.loading = true;
      const { start_at, end_at } = this.period;
      const filter_by = "done_at";
      const range = this.range;
      const count = "user_id";
      const queries = `start_at=${start_at}&end_at=${end_at}&filter_by=${filter_by}&range_type=${range}&count_by=${count}`;

      const apiUrl = `apps/${this.appCode}/stats/ranged/user-activities?${queries}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.formatChartData(resData);
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },

    formatChartData(data) {
      this.labels = [];
      this.data = [];

      if (data.length === 0) {
        return;
      }

      const { start_at, end_at } = this.period;
      let dates = {
        [start_at]: 0
      };
      let date_at = start_at;

      while (date_at < end_at) {
        date_at = this.mFormatIntervalDate(date_at, 1);
        dates[date_at] = 0;
      }

      dates = {
        ...dates,
        ...data
      };
      Object.keys(dates).forEach(date => {
        this.labels.push(this.mFormatShortDate(date, "m-d"));
        this.data.push(dates[date]);
      });
    }
  }
};
</script>

<style></style>
